import { render, staticRenderFns } from "./SendSepaNonreceiptClaimModal.vue?vue&type=template&id=2595a825"
import script from "./SendSepaNonreceiptClaimModal.vue?vue&type=script&lang=js"
export * from "./SendSepaNonreceiptClaimModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports